var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "FineCenter__Import__View" }, [
    _c("h1", [_vm._v("ייבוא מרכז לגביית קנסות")]),
    _c("div", { staticClass: "FineCenter__Import__View__Steps" }, [
      _c(
        "section",
        [
          _c(
            "b-steps",
            {
              scopedSlots: _vm._u([
                {
                  key: "navigation",
                  fn: function(ref) {
                    var previous = ref.previous
                    var next = ref.next
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeStep !== 5,
                              expression: "activeStep !== 5"
                            }
                          ],
                          staticClass: "Navigation"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { outlined: "", type: "is-primary" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onPrevious(previous)
                                }
                              }
                            },
                            [_vm._v("חזור")]
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: { outlined: "", type: "is-primary" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onNext(next)
                                }
                              }
                            },
                            [_vm._v("המשך")]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.activeStep,
                callback: function($$v) {
                  _vm.activeStep = $$v
                },
                expression: "activeStep"
              }
            },
            [
              _c("b-step-item", { attrs: { label: "בחירת קובץ" } }, [
                _c(
                  "div",
                  { staticClass: "ChooseFile__Step" },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "בחר קובץ לייבוא" } },
                      [
                        _c(
                          "b-field",
                          {
                            staticClass: "file is-primary",
                            class: { "has-name": !!_vm.file }
                          },
                          [
                            _c(
                              "b-upload",
                              {
                                staticClass: "file-label",
                                attrs: { rounded: "", accept: ".xlsx,.xls" },
                                model: {
                                  value: _vm.file,
                                  callback: function($$v) {
                                    _vm.file = $$v
                                  },
                                  expression: "file"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "file-cta" },
                                  [
                                    _c("b-icon", {
                                      staticClass: "file-icon",
                                      attrs: { icon: "upload" }
                                    }),
                                    _c("span", { staticClass: "file-label" }, [
                                      _vm._v("בחר קובץ...")
                                    ])
                                  ],
                                  1
                                ),
                                _vm.file
                                  ? _c("span", { staticClass: "file-name" }, [
                                      _vm._v(" " + _vm._s(_vm.file.name) + " ")
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("p", { staticClass: "help" }, [
                      _vm._v(
                        " קובץ אקסל שהורד מהאזור האישי של מרכז לגביית קנסות — ללא הכנה מוקדמת "
                      )
                    ])
                  ],
                  1
                )
              ]),
              _c(
                "b-step-item",
                { attrs: { clickable: false, label: "ניתוח קובץ" } },
                [
                  _c(
                    "div",
                    { staticClass: "Progress__Step" },
                    [
                      _c("b-progress", {
                        attrs: {
                          type: "is-primary",
                          value: _vm.progress,
                          "show-value": "",
                          format: "percent"
                        }
                      }),
                      _c("p", { staticClass: "has-text-centered mt-3" }, [
                        _vm._v("מנתח את הקובץ...")
                      ])
                    ],
                    1
                  )
                ]
              ),
              _c("b-step-item", { attrs: { label: "מיפוי שדות" } }, [
                _vm.tableData.length
                  ? _c(
                      "div",
                      { staticClass: "ColumnReview__Step" },
                      [
                        _c(
                          "b-message",
                          {
                            staticClass: "mb-3",
                            attrs: { type: "is-info", size: "is-small" }
                          },
                          [
                            _vm._v(
                              " העמודות זוהו אוטומטית. ניתן לשנות את המיפוי לפני שממשיכים. "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "table-scrollable" },
                          [
                            _c("table-selectable", {
                              ref: "table",
                              attrs: {
                                "show-row-number": true,
                                "starting-row": 1,
                                headers: _vm.columnHeaders,
                                data: _vm.tableData
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("b-step-item", { attrs: { label: "אישור ייבוא" } }, [
                _vm.analyzeResult
                  ? _c("div", { staticClass: "Confirm__Step" }, [
                      _c("div", { staticClass: "box mb-5" }, [
                        _c("h3", { staticClass: "subtitle mb-2" }, [
                          _vm._v("פרטי הקובץ")
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("ח.פ שנמצא בקובץ:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.analyzeResult.DetectedIdNumber || "—")
                          )
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("מספר דוחות לייבוא:")]),
                          _vm._v(" " + _vm._s(_vm.analyzeResult.RowCount))
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("שם קובץ:")]),
                          _vm._v(" " + _vm._s(_vm.analyzeResult.FileName))
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "mb-5" },
                        [
                          _c("h3", { staticClass: "subtitle mb-2" }, [
                            _vm._v("פרופיל")
                          ]),
                          _vm.selectedProfile
                            ? _c(
                                "div",
                                { staticClass: "detected-profile mb-3" },
                                [
                                  _c(
                                    "b-tag",
                                    {
                                      attrs: {
                                        type: "is-success",
                                        size: "is-medium"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.selectedProfile.Name) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "ml-1" }, [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              _vm.selectedProfile.IdNumber
                                            ) +
                                            ")"
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { size: "is-small" },
                                      on: {
                                        click: function($event) {
                                          _vm.showProfileSearch = !_vm.showProfileSearch
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.showProfileSearch
                                              ? "סגור"
                                              : "שנה פרופיל"
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _c(
                                "b-message",
                                {
                                  attrs: {
                                    type: "is-warning",
                                    size: "is-small"
                                  }
                                },
                                [
                                  _vm._v(
                                    " לא נמצא פרופיל תואם לח.פ " +
                                      _vm._s(
                                        _vm.analyzeResult.DetectedIdNumber
                                      ) +
                                      ". אנא בחר פרופיל ידנית. "
                                  )
                                ]
                              ),
                          _vm.showProfileSearch || !_vm.selectedProfile
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    { staticClass: "is-flex mb-2" },
                                    [
                                      _c(
                                        "b-field",
                                        {
                                          staticClass: "ml-3",
                                          attrs: { label: "חפש פרופיל" }
                                        },
                                        [
                                          _c("b-input", {
                                            attrs: { placeholder: "שם / ח.פ" },
                                            model: {
                                              value: _vm.profileTerm,
                                              callback: function($$v) {
                                                _vm.profileTerm = $$v
                                              },
                                              expression: "profileTerm"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-field",
                                        { attrs: { label: "מנוהלים בלבד" } },
                                        [
                                          _c(
                                            "b-switch",
                                            {
                                              staticClass: "ltr pt-2",
                                              model: {
                                                value: _vm.isManaged,
                                                callback: function($$v) {
                                                  _vm.isManaged = $$v
                                                },
                                                expression: "isManaged"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.isManaged ? "כן" : "לא"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-table",
                                    {
                                      attrs: {
                                        data: _vm.filteredProfiles,
                                        selected: _vm.selectedProfile,
                                        striped: true,
                                        hoverable: true,
                                        loading: _vm.isLoadingProfiles,
                                        paginated: "",
                                        "per-page": "10",
                                        "pagination-simple": true,
                                        "default-sort": "Id",
                                        "sticky-header": true
                                      },
                                      on: {
                                        "update:selected": function($event) {
                                          _vm.selectedProfile = $event
                                        },
                                        click: _vm.onProfileClick
                                      }
                                    },
                                    [
                                      _c("b-table-column", {
                                        attrs: {
                                          field: "Id",
                                          label: "מזהה",
                                          centered: "",
                                          sortable: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(props) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(props.row.Id) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          116998704
                                        )
                                      }),
                                      _c("b-table-column", {
                                        attrs: {
                                          label: "ח.פ/ת.ז",
                                          centered: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(props) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.IdNumber
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1533233651
                                        )
                                      }),
                                      _c("b-table-column", {
                                        attrs: {
                                          field: "Name",
                                          label: "שם",
                                          sortable: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(props) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(props.row.Name) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          361322874
                                        )
                                      }),
                                      _c("b-table-column", {
                                        attrs: { label: "כתובת" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(props) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getAddress(
                                                          props.row
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3446710450
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "settings-section" },
                        [
                          _c("h3", { staticClass: "subtitle mb-2" }, [
                            _vm._v("הגדרות")
                          ]),
                          _c(
                            "b-field",
                            { attrs: { label: "הערה" } },
                            [
                              _c("b-input", {
                                model: {
                                  value: _vm.comment,
                                  callback: function($$v) {
                                    _vm.comment = $$v
                                  },
                                  expression: "comment"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "תאריך קובע" } },
                            [
                              _c("b-datepicker", {
                                attrs: {
                                  placeholder: "לחץ כדי לבחור",
                                  "icon-prev": "chevron-right",
                                  "icon-next": "chevron-left",
                                  icon: "calendar-today",
                                  locale: "en-GB",
                                  "day-names": [
                                    "א",
                                    "ב",
                                    "ג",
                                    "ד",
                                    "ה",
                                    "ו",
                                    "ש"
                                  ],
                                  "month-names": [
                                    "ינואר",
                                    "פברואר",
                                    "מרץ",
                                    "אפריל",
                                    "מאי",
                                    "יוני",
                                    "יולי",
                                    "אוגוסט",
                                    "ספטמבר",
                                    "אוקטובר",
                                    "נובמבר",
                                    "דצמבר"
                                  ],
                                  "close-on-click": "",
                                  editable: "",
                                  "append-to-body": ""
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "ייבוא ראשוני" } },
                            [
                              _c(
                                "b-switch",
                                {
                                  model: {
                                    value: _vm.isFirstTime,
                                    callback: function($$v) {
                                      _vm.isFirstTime = $$v
                                    },
                                    expression: "isFirstTime"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.isFirstTime ? "כן" : "לא") +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]),
              _c(
                "b-step-item",
                {
                  attrs: {
                    clickable: false,
                    label: "מייבא נתונים",
                    visible: _vm.isImporting
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "importing-step" },
                    [
                      _c("b-loading", {
                        attrs: { "is-full-page": false, "can-cancel": false },
                        model: {
                          value: _vm.isImporting,
                          callback: function($$v) {
                            _vm.isImporting = $$v
                          },
                          expression: "isImporting"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "b-step-item",
                { staticClass: "table-item", attrs: { label: "סטטוס" } },
                [
                  _c("div", { staticClass: "status-step" }, [
                    _c("div", { staticClass: "results-reports" }, [
                      _vm.isLoading
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                gap: "10px"
                              }
                            },
                            [
                              _c("span", [_vm._v("מעבד...")]),
                              _c("b-icon", {
                                attrs: {
                                  pack: "fas",
                                  icon: "sync-alt",
                                  "custom-class": "fa-spin"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.succeeded
                        ? _c("p", [
                            _vm._v("דוחות שהתקבלו: " + _vm._s(_vm.succeeded))
                          ])
                        : _vm._e(),
                      _vm.notSucceeded
                        ? _c("p", [
                            _vm._v(
                              "דוחות שלא התקבלו: " + _vm._s(_vm.notSucceeded)
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      { staticClass: "is-flex is-justify-content-flex-end" },
                      [
                        _c(
                          "b-tooltip",
                          { attrs: { label: "ייצוא לאקסל" } },
                          [
                            _c(
                              "b-button",
                              { on: { click: _vm.exportToExcel } },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "file-excel-outline" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.results.rows.length
                      ? _c("table", { staticClass: "table" }, [
                          _c("thead", [
                            _c(
                              "tr",
                              _vm._l(_vm.results.headers, function(header, i) {
                                return _c("th", { key: i }, [
                                  _vm._v(_vm._s(header))
                                ])
                              }),
                              0
                            )
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.results.rows, function(row, ri) {
                              return _c(
                                "tr",
                                {
                                  key: ri,
                                  class: { "has-error": !row.Succeeded }
                                },
                                _vm._l(row.data, function(value, vi) {
                                  return _c("td", { key: vi }, [
                                    _vm._v(_vm._s(value))
                                  ])
                                }),
                                0
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm.activeStep === 5
                ? [
                    _c(
                      "div",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { type: "is-primary" },
                            on: { click: _vm.reset }
                          },
                          [_vm._v("התחל ייבוא חדש")]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }